import React from "react";
import PropTypes from "prop-types";
import Loading from "components/Loading";

const SignIn = ({ signIn, loading }) => {
  return loading ? (
    <Loading />
  ) : (
    <>
      <div className="contentPage__headingDiv">
        <h1>Purchase History</h1>
        <h6>
          Please sign in to see purchases you&apos;ve made through the online
          store.
        </h6>
      </div>
      <div className="purchaseHistoryBlock" style={{ position: "relative" }}>
        <div className="purchaseHistory__signin__register__button__container">
          <button
            className="purchaseHistory__signin__register__button"
            type="button"
            onClick={() => {
              signIn();
            }}
          >
            Sign In
          </button>
        </div>
      </div>
    </>
  );
};

SignIn.propTypes = {
  loading: PropTypes.bool.isRequired,
  signIn: PropTypes.func.isRequired
};

export default SignIn;
